module.exports = __webpack_public_path__ + "book_2-1b0d0d3e1c108c44f8a59871373e7ab8.png";